export default __webpack_public_path__ + "static/media/plain-sticker-P.66f83c4f.png";